module.exports = __webpack_public_path__ + "static/media/ssss.4c95b45a.jpg";